/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

import { VueCookieNext } from 'vue-cookie-next';
import { useAuthStore } from "../stores/auth";

export const useAuth = () => {
  const setToken = (token: string): void => {
    VueCookieNext.setCookie('token', token);
    // console.log('setToken: ' + token);
    const element = document.getElementById('nav');
    if (element !== null && element !== undefined)
      element.style.display = 'flex';
  };

  const logout = async (): Promise<void> => {
    VueCookieNext.removeCookie('token');
    const authStore = useAuthStore();
    authStore.logout();
    // console.log('****  logout  ****');
    // Lazy import to avoid circular dependency
    const { router } = await import('../app');
    router.push('/login');
    const element = document.getElementById('nav');
    if (element !== null && element !== undefined)
      element.style.display = 'none';
  };

  const getToken = (): string | null => {
    const token = VueCookieNext.getCookie('token');
    // console.log('getToken: ' + token);
    return token;
  };

  return {
    setToken,
    logout,
    getToken,
  };
};
